import type {ContentHomeResponse} from '@/ts/types/dto/home-dto';
import type {Content} from '@/ts/types/dto/interventions-dto';

/**
 * The intro video: the first featured piece of content, and only if it has a video to play.
 *
 * Two callers on paper, one in practice: the FAQ panel, and the home page the Today page replaced,
 * which is no longer routed and goes out with the cleanup that follows. Kept as a function of its
 * own rather than folded into the panel, since which piece counts as the intro video is a rule
 * about the content and not about the surface that happens to show it.
 */
export function featuredIntroVideo(home: ContentHomeResponse | null | undefined): Content | null {
  const featured = home?.featuredBlockContent?.[0];
  return featured?.video ? featured : null;
}
